// src/App.js
import React from 'react';
import { AppProvider, useApp } from './context/AppContext';
import BottomNavigation from './components/layout/BottomNavigation';

// Importuri directe pentru paginile principale
import Home from './pages/Home';
import Search from './pages/Search';
import SearchScreen from './pages/Search/SearchScreen';
import SalonDetails from './pages/SalonDetails';
import Notifications from './pages/Notifications';
import { AppointmentDetails } from './pages/Appointments';

// Importuri directe pentru componentele de booking
import { SpecialistsScreen } from './pages/Booking/components';
import { ServicesScreen } from './pages/Booking/components';
import { SelectDateScreen } from './pages/Booking/components';
import { ConfirmationScreen } from './pages/Booking/components';

// Importuri directe pentru componentele de profil
import { ProfileScreen } from './pages/Profile/components';
import { FavoritesScreen } from './pages/Profile/components';
import { AppointmentsScreen } from './pages/Profile/components';

// Main app component with context
const AppContent = () => {
  const appContext = useApp();
  const { currentScreen, shouldShowBottomNav, navigateTo } = appContext;

  // Render the current screen
  const renderScreen = () => {
    switch (currentScreen) {
      case 'home':
        return <Home />;
      case 'search':
        return <Search />;
      case 'searchScreen':
        return <SearchScreen />;
      case 'salon':
        return <SalonDetails />;
      case 'specialists':
        return <SpecialistsScreen />;
      case 'services':
        return <ServicesScreen />;
      case 'selectDate':
        return <SelectDateScreen />;
      case 'confirmation':
        return <ConfirmationScreen />;
      case 'profile':
        return <ProfileScreen />;
      case 'favorites':
        return <FavoritesScreen />;
      case 'appointments':
        return <AppointmentsScreen />;
      case 'notifications':
        return <Notifications />;
      case 'appointmentDetails':
        return <AppointmentDetails />;
      default:
        return <Home />;
    }
  };

  return (
    <div className="flex flex-col h-screen bg-gray-50">
      {renderScreen()}
      {shouldShowBottomNav() && <BottomNavigation currentScreen={currentScreen} navigateTo={navigateTo} />}
    </div>
  );
};

// App wrapper with context provider
const App = () => {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
};

export default App;